import { proxy, snapshot, useSnapshot } from 'valtio';

import { devtoolsApi } from '#/dev/devtools';

import { resetStore } from '../common';

export interface ModalStore {
  isModalVisible: boolean;
  opts: ModalStateOpts;
  /** Flag indicating if a full page modal is currently mounted */
  isFullPageModalOpen: boolean;
}
export interface ModalStateOpts {
  /** Message text to be displayed in the modal */
  message: string;

  /** @optional Modal title to be shown in the modal */
  title?: string;

  /** @optional Text visible on the CTA button in the modal @default `tb('button.ok')` */
  buttonLabel?: string;

  /** @optional A function to call when closing the modal box */
  onDismiss?: () => void;

  /** @optional A function to call when clicking on the modal button,
   * if it is not given, onDismiss will run on button click as well */
  onOk?: () => void;
}

export const modalStore = proxy<ModalStore>({
  isModalVisible: false,
  opts: { message: '' },
  isFullPageModalOpen: false,
});

const initialModalStore = snapshot(modalStore) as ModalStore;

export const modalActions = {
  showModal(opts: ModalStateOpts) {
    modalStore.opts = opts;
    modalStore.isModalVisible = true;
  },
  hideModal() {
    modalStore.opts = initialModalStore.opts;
    modalStore.isModalVisible = false;
  },
  setFullPageModalOpen(isOpen: boolean) {
    modalStore.isFullPageModalOpen = isOpen;
  },
  reset() {
    resetStore(modalStore, initialModalStore);
  },
};

export const useModalStore = () => useSnapshot(modalStore) as ModalStore;

devtoolsApi.setStore('modal', modalStore, modalActions);
